import React, { useState } from "react";
import { useScreenSize } from "../../utils";
import MobileSideBar from "./MobileSideBar/MobileSideBar";
import DesktopSideBar from "./DesktopSideBar/DesktopSideBar";
import { FaRegCalendarAlt } from "react-icons/fa";
import style from "./ResponsiveSideBar.module.css";
import { NavLink, useNavigate } from "react-router-dom";
import { useAppContext } from "../../context";
import { CgProfile } from "react-icons/cg";
import { IoQrCodeOutline } from "react-icons/io5";
import { IoMdPersonAdd } from "react-icons/io";
import { GiTeacher } from "react-icons/gi";
import { BsCashCoin } from "react-icons/bs";
import { SiGoogleclassroom } from "react-icons/si";
import { MdOutlineLogout } from "react-icons/md";
import { logOut } from "../../utils/auxiliarFunctions";

const ResponsiveSideBar = ({ children }) => {
  const [sidebarExpanded, setSidebarExpanded] = useState(false);
  const screenSize = useScreenSize();
  const { user } = useAppContext();
  const navigate = useNavigate();

  const handleLogOut = async () => {
    try {
      await logOut();
      sessionStorage.clear();
      navigate(`/`);
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    }
  }

  const getLinkClassName = (isActive) => {
    return isActive
      ? `${style.activeLink} ${sidebarExpanded ? style.expandedActiveLink : ""}`
      : `${style.links} ${sidebarExpanded ? style.expandedLink : ""}`;
  };


  const sideBarLinks =
    <>
      <NavLink
        onClick={() => setSidebarExpanded(false)}
        to={user?.role === '1' ? '/homeAdmin' : '/homeAlumno'}
        className={({ isActive }) => getLinkClassName(isActive)}
      >
        <FaRegCalendarAlt />
        {sidebarExpanded && <p className={`m-0 ${style.linkTxt}`}>Calendario</p>}
      </NavLink>
      <NavLink
        onClick={() => setSidebarExpanded(false)}
        to="/perfil"

        className={({ isActive }) => getLinkClassName(isActive)}
      >
        <CgProfile />
        {sidebarExpanded && <p className={`m-0 ${style.linkTxt}`}>Perfil</p>}
      </NavLink>
      {(user?.role === '1' || user?.role === '3') &&
        <NavLink
          onClick={() => setSidebarExpanded(false)}
          to="/qrScanner"
          className={({ isActive }) => getLinkClassName(isActive)}
        >
          <IoQrCodeOutline />
          {sidebarExpanded && <p className={`m-0 ${style.linkTxt}`}>Escanear QR</p>}
        </NavLink>
      }
      {user?.role === '1' &&
        <>
          <NavLink
            onClick={() => setSidebarExpanded(false)}
            to="/altaUsuario"
            className={({ isActive }) => getLinkClassName(isActive)}
          >
            <IoMdPersonAdd />
            {sidebarExpanded && <p className={`m-0 ${style.linkTxt}`}>Alta de usuarios</p>}
          </NavLink>

          <NavLink
            onClick={() => setSidebarExpanded(false)}
            to="/listaProfesores"
            className={({ isActive }) => getLinkClassName(isActive)}
          >
            <GiTeacher />
            {sidebarExpanded && <p className={`m-0 ${style.linkTxt}`}>Lista de Profesores</p>}
          </NavLink>

          <NavLink
            onClick={() => setSidebarExpanded(false)}
            to="/alumnos"
            className={({ isActive }) => getLinkClassName(isActive)}
          >
            <BsCashCoin />
            {sidebarExpanded && <p className={`m-0 ${style.linkTxt}`}>Pagos</p>}
          </NavLink>
          <NavLink
            onClick={() => setSidebarExpanded(false)}
            to="/actividades"
            className={({ isActive }) => getLinkClassName(isActive)}
          >
            <SiGoogleclassroom />
            {sidebarExpanded && <p className={`m-0 ${style.linkTxt}`}>Actividades</p>}
          </NavLink>
        </>
      }
      {(user?.role === '2' || user?.role === '3') &&
        <NavLink
          onClick={() => setSidebarExpanded(false)}
          to="/qr"
          className={({ isActive }) => getLinkClassName(isActive)}
        >
          <IoQrCodeOutline />
          {sidebarExpanded && <p className={`m-0 ${style.linkTxt}`}>Mi QR</p>}
        </NavLink>
      }
      <NavLink
        onClick={handleLogOut}
        className={`${style.links} ${sidebarExpanded ? `${style.expandedLink} ${style.logoutLink}` : ""}`}
      >
        <MdOutlineLogout />
        {sidebarExpanded && <p className={`m-0 ${style.linkTxt}`}>Cerrar sesión</p>}
      </NavLink>
    </>

  if (screenSize < 1000) {
    return (
      <>
        <MobileSideBar sidebarExpanded={sidebarExpanded} setSidebarExpanded={setSidebarExpanded}>
          {sideBarLinks}
        </MobileSideBar>
        {children}
      </>
    )
  } else {
    return (
      <>
        <DesktopSideBar sidebarExpanded={sidebarExpanded} setSidebarExpanded={setSidebarExpanded}>
          {sideBarLinks}
        </DesktopSideBar>
        <div className="main" style={{
          marginLeft: sidebarExpanded ?
            screenSize > 992 ? "11rem" : "9rem" :
            screenSize > 992 ? "2%" : "8%",
          transition: "margin-left 1s ease-in-out",
          /* padding: "1rem" */
        }}>
          {children}
        </div>
      </>
    )
  }
}

export default ResponsiveSideBar
